module.exports = __webpack_public_path__ + "images/marketing/peeps/scott_gibson.png";